import React, { useState, useEffect } from 'react'

import { Grid, Typography, Box } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import CloseIcon from '@mui/icons-material/Close';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';
import PlayCircleOutlineIcon from '@mui/icons-material/PlayCircleOutline';

import { CoreContext } from '../../../core/context/CoreContext';
import { useDispatch, useSelector } from 'react-redux';
import AssetsListTableHeader from './AssetsListTableHeader';
import AssetsListTableRow from './AssetsListTableRow';
import IconEnabled from 'core/components/layout/IconEnabled';
import { deleteAPI as deleteAsset } from '../AssetsAPI';
import { deleteAssetsObj } from 'store/slice/ManufSlice';

export default function AssetsListTable({ payload }) {

  const [showLoading, setShowLoading] = useState(false);
  const [columns, setColumns] = useState([]);
  const [rows, setRows] = useState([]);
  const { userprofileInfo } = useSelector((state) => state.headerslice);
  const { assetsList } = useSelector((state) => state.manufslice.assetsDashboard);
  const [openVideo, setOpenVideo] = useState(false);
  const [videoSrc, setVideoSrc] = useState('');
  const [deleteConfirm, setDeleteConfirm] = useState({ open: false, asset: null });
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [deletedAssetTitle, setDeletedAssetTitle] = useState('');
  const dispatch = useDispatch();

  useEffect(() => {
    
    //if (rows.length === 0)
   // setRows(assetsList);
  }, [assetsList])

  const handleRowClick = (rowId) => {
    setRows(prevData =>
      prevData.map(item =>
        item.id === rowId ? { ...item, 'expand': !item.expand } : item
      )
    );
  }

  const getActionComponent = (rowObj) => {
    return <>
      {payload.actionList
        .filter(actionObj =>
          actionObj.status !== undefined &&
          actionObj.status.toLowerCase().includes(rowObj.orderstatusname.toLowerCase())
        )
        .map(actionObj => (
          <IconEnabled key={`${rowObj.id}-${actionObj.id}`} actionObj={actionObj} id={rowObj.id} />
        ))
      }
    </>
  }
  const isVideo = (path) =>
    /\.(mp4|webm|ogg|mov|mkv)$/i.test(path);

  const handleDelete = async (assetObj) => {
    setDeleteConfirm({ open: false, asset: null });
    setShowLoading(true);
    try {
      await deleteAsset(assetObj.id, () => { });
      dispatch(deleteAssetsObj(assetObj.id)); // Dispatch redux action on success
      setDeletedAssetTitle(assetObj.title);   // Save deleted asset title
      setSnackbarOpen(true);                  // Show snackbar on success
    } catch (e) {
      // Handle error (show notification, etc.)
    }
    setShowLoading(false);
  };

  return (
    <>
      <Box lg={12} sx={{ flexGrow: 1 }}>
        <Grid item lg={12} sx={{ overflowY: "scroll", maxHeight: '75vh' }}>
          <Grid container direction="row" sx={{ justifyContent: "flex-start", width: '100%', backgroundColor: 'white', p: .5 }}>
            {assetsList.map(assetObj => (
              <Grid item lg={2} md={2} sm={3} xs={6} key={assetObj.name + assetObj.path} sx={{ p: 1 }}>
                <Box
                  sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'flex-start',
                    backgroundColor: 'secondary.100',
                    borderRadius: '8px',
                    width:'150px'
                  }}
                >
                  <Box
                    sx={{
                      borderRadius: '5px',
                      overflow: 'hidden',
                      transition: 'background 0.2s',
                      background: 'transparent',
                      '&:hover': {
                        background: '#f0f7ff',
                      },
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'flex-start',
                      cursor: 'pointer',
                      p: 1,
                      position: 'relative', // Add for icon overlay
                    }}
                    title={assetObj.title}
                    onClick={() => {
                      if (isVideo(assetObj.path)) {
                        setVideoSrc(assetObj.path);
                        setOpenVideo(true);
                      }
                    }}
                  >
                    {assetObj.path && isVideo(assetObj.path) ? (
                      <>
                        <video
                          src={assetObj.path}
                          style={{
                            width: '100px',
                            height: '100px',
                            objectFit: 'cover',
                            borderRadius: '5px',
                            background: 'transparent',
                          }}
                          muted
                          preload="metadata"
                        />
                        <PlayCircleOutlineIcon
                          sx={{
                            position: 'absolute',
                            top: '50%',
                            left: '50%',
                            transform: 'translate(-50%, -50%)',
                            color: '#fff',
                            fontSize: 48,
                            opacity: 0.8,
                            pointerEvents: 'none'
                          }}
                        />
                      </>
                    ) : (
                      <img
                        src={assetObj.path}
                        alt={assetObj.title}
                        title={assetObj.title}
                        style={{
                          border: '.5px solid #0050b3',
                          height: '20vh',
                          borderRadius: '5px',
                          background: 'transparent',
                          objectFit: 'contain'
                        }}
                      />
                    )}
                  </Box>
                  <Box sx={{ display: 'flex', alignItems: 'center', width: '100%', p: 1, justifyContent: 'space-between' }}>
                    <Typography
                      variant="h6"
                      noWrap
                      title={assetObj.title}
                      sx={{
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap',
                        display: 'block',
                        cursor: isVideo(assetObj.path) ? 'pointer' : 'pointer',
                        color: '#1976d2',
                        textDecoration: 'underline',
                        fontWeight: 500,
                        textAlign: 'left',
                        '&:hover': {
                          color: '#1565c0',
                          textDecoration: 'underline',
                        },
                      }}
                      onClick={() => {
                        if (isVideo(assetObj.path)) {
                          setVideoSrc(assetObj.path);
                          setOpenVideo(true);
                        }
                      }}
                    >
                      {assetObj.title}
                    </Typography>
                    <DeleteIcon
                      sx={{
                        color: 'error.main',
                        ml: 1,
                        cursor: 'pointer'
                      }}
                      onClick={() => setDeleteConfirm({ open: true, asset: assetObj })}
                    />
                  </Box>
                </Box>
              </Grid>
            ))}
            {
              rows.length === 0 ?
                <Grid
                  container
                  direction="row"
                  justifyContent="center"
                  alignItems="center"
                  sx={{ width: '100%', backgroundColor: '#fafafa' }}
                  padding={1}
                >
                  <Typography sx={{ fontWeight: 'light', fontSize: 14 }}><i>Records(s) are not added, yet.</i></Typography>
                </Grid>
                : <></>
            }
          </Grid>
        </Grid>
      </Box>
      {/* Video Popup Dialog */}
      {openVideo && (
        <Box
          sx={{
            position: 'fixed',
            top: 0, left: 0, width: '100vw', height: '100vh',
            background: 'rgba(0,0,0,0.7)',
            zIndex: 1300,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}
          onClick={() => setOpenVideo(false)}
        >
          <Box
            sx={{
              background: '#fff',
              borderRadius: 2,
              p: 2,
              maxWidth: '90vw',
              maxHeight: '80vh',
              boxShadow: 24,
              position: 'relative'
            }}
            onClick={e => e.stopPropagation()}
          >
            <video
              src={videoSrc}
              controls
              autoPlay
              style={{ maxWidth: '80vw', maxHeight: '70vh', display: 'block' }}
            />
            <Box sx={{ position: 'absolute', top: 8, right: 8 }}>
              <CloseIcon
                sx={{ cursor: 'pointer', color: 'error.main', fontSize: 32 }}
                onClick={() => setOpenVideo(false)}
              />
            </Box>
          </Box>
        </Box>
      )}
      {/* Delete Confirmation Dialog */}
      {deleteConfirm.open && (
        <Box
          sx={{
            position: 'fixed',
            top: 0, left: 0, width: '100vw', height: '100vh',
            background: 'rgba(0,0,0,0.3)',
            zIndex: 1400,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}
        >
          <Box
            sx={{
              background: '#fff',
              borderRadius: 2,
              p: 3,
              minWidth: 300,
              boxShadow: 24,
              textAlign: 'center'
            }}
          >
            <Typography variant="h6" sx={{ mb: 2 }}>
              Are you sure you want to delete <b>{deleteConfirm.asset?.title}</b>?
            </Typography>
            <Box sx={{ display: 'flex', justifyContent: 'center', gap: 2, mt: 2 }}>
              <button
                style={{ padding: '6px 18px', background: '#d32f2f', color: '#fff', border: 'none', borderRadius: 4, cursor: 'pointer' }}
                onClick={() => handleDelete(deleteConfirm.asset)}
              >
                Delete
              </button>
              <button
                style={{ padding: '6px 18px', background: '#e0e0e0', color: '#333', border: 'none', borderRadius: 4, cursor: 'pointer' }}
                onClick={() => setDeleteConfirm({ open: false, asset: null })}
              >
                Cancel
              </button>
            </Box>
          </Box>
        </Box>
      )}
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={3000}
        onClose={() => setSnackbarOpen(false)}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        <MuiAlert onClose={() => setSnackbarOpen(false)} severity="success" sx={{ width: '100%' }}>
          Asset <b>{deletedAssetTitle}</b> deleted successfully!
        </MuiAlert>
      </Snackbar>
    </>
  );


}